var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 21.3096552 0 21.3096552 16.0595448 0 16.0595448"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3096552,10.4085793 L21.3096552,10.7575448 C21.3096552,13.6850621 18.9351724,16.0595448 16.0068966,16.0595448 L12.0165517,16.0595448 L12.0165517,10.765131 L14.6034483,10.765131 L11.1441379,6.09885517 L10.6510345,5.43126897 L10.1427586,6.09885517 L7.89724138,9.06506207 L6.60758621,10.765131 L9.3537931,10.765131 L9.3537931,16.0595448 L5.30275862,16.0595448 C2.37448276,16.0595448 0,13.6850621 0,10.7575448 L0,10.4085793 C0,8.57271724 1.16068966,6.99478621 2.78413793,6.38713103 C2.7462069,6.19747586 2.73103448,6.00023448 2.73103448,5.80375172 C2.73103448,4.06651034 4.13448276,2.66306207 5.86413793,2.66306207 C6.47862069,2.66306207 7.04758621,2.83754483 7.53310345,3.14857931 C8.48896552,1.27478621 10.4386207,-0.000455172414 12.6917241,-0.000455172414 C15.8931034,-0.000455172414 18.4875862,2.59402759 18.4875862,5.80375172 C18.4875862,5.9934069 18.48,6.17547586 18.4572414,6.35754483 C20.1262069,6.94851034 21.3096552,8.54237241 21.3096552,10.4085793",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic_upload.5bcbb066.svg";
export { ForwardRef as ReactComponent };